import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=00c64a1f&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=00c64a1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c64a1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00c64a1f')) {
      api.createRecord('00c64a1f', component.options)
    } else {
      api.reload('00c64a1f', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=00c64a1f&scoped=true&", function () {
      api.rerender('00c64a1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24dGlewkPm8C3/JS/comp/GuestBox.vue"
export default component.exports